module.exports = __webpack_public_path__ + "img/zhizuofangf.fc5a4d94.png";